export default "__VITE_ASSET__08828384__"